export default {
    methods: {
        trackEvent(name, subEvent, updateDocumentTitle = true) {
            let eventName = `Autodesk One - ${name}`;
            let params = {}
            if (subEvent) {
                params.subEvent = subEvent
            }


            this.$hhMixpanel.trackEvent(eventName, params);
            if(updateDocumentTitle)
                document.title = eventName;
        },
        trackBrowseActions(platform, subEvent, updateDocumentTitle = true) {
            this.trackEvent(`${platform} Browse Actions`, subEvent, updateDocumentTitle);

        },
        trackBottomBanner(subEvent) {
            this.trackEvent("Home Page Bottom Banner", subEvent);
        },
        trackAnnouncement(subEvent) {
            this.trackEvent("Announcement", subEvent);
        },
        trackQuickSolutions(subEvent) {
            this.trackEvent("Quick solutions", subEvent);
        },
        trackCampaign(subEvent) {
            this.trackEvent("Campaign Banner", subEvent);
        },
        trackOutageAnnouncement(subEvent) {
            this.trackEvent("Outage Announcement", subEvent);
        },
        trackNewsSummarizationFeedback(helpful) {
            let helpfulStr = helpful ? "Yes" : "No";
            this.trackEvent(`News summarization feedback relevant: ${helpfulStr}`);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/MixpanelMixin.js